import AboutMe from "../AboutMe";

import Footer from "../Footer";
import HeroSection from "../HeroSection";
import MyPortfolio from "../MyPortfolio";
import MySkills from "../MySkills";
import ParticlesFall from "../Particles/particles";

export default function Home() {
  return (
    <>
      <ParticlesFall/>
      <HeroSection />
      <MySkills />
      <AboutMe />
      <MyPortfolio />
      {/* <Testimonial />
      <ContactMe /> */}
      <Footer />
    </>
  );
}
